import { Controller } from "@hotwired/stimulus"

// BandiProgetto.js, «Mostra solo i bandi coerenti con l'idea» (soloCoerenti): nasconde i bandi non scelti con una
// coerenza diversa da «coerente» (data-nascondibile="true"); i bandi scelti restano sempre in vista. Come il `continue`
// dell'originale, il bando nascosto non conta: ogni sezione riconta i suoi bandi ([data-conteggio]) e sparisce se resta
// vuota. Lo stato vive sul contenitore della pagina: quando una scrittura riscrive la pagina la casella torna com'era.
//   <div data-controller="solo-coerenti">
//     <input type="checkbox" data-solo-coerenti-target="casella" data-action="solo-coerenti#cambia">
//     <section data-solo-coerenti-target="sezione"> … (<span data-conteggio>3</span>)
//       <div data-solo-coerenti-target="riga" data-nascondibile="true">
export default class extends Controller {
  static targets = ["casella", "sezione", "riga"]

  initialize() {
    this.attivo = false
  }

  casellaTargetConnected(casella) {
    casella.checked = this.attivo
    this.applica()
  }

  cambia(event) {
    this.attivo = event.target.checked
    this.applica()
  }

  applica() {
    for (const riga of this.rigaTargets) riga.hidden = this.attivo && riga.dataset.nascondibile === "true"
    for (const sezione of this.sezioneTargets) {
      const visibili = this.rigaTargets.filter((r) => sezione.contains(r) && !r.hidden).length
      const conteggio = sezione.querySelector("[data-conteggio]")
      if (conteggio) conteggio.textContent = String(visibili)
      sezione.hidden = visibili === 0
    }
  }
}
